import { WhatsappLogo } from "@phosphor-icons/react";
import { useSettings } from "@/contexts/SettingsContext";

// A floating chat bubble fixed to the bottom-right corner of every public page.
// Number, label and visibility all editable once from Admin -> Header.
export const WhatsAppBubble = () => {
  const settings = useSettings();
  const number = settings.whatsapp_number;

  if (settings.whatsapp_enabled === false || !number) return null;

  return (
    <a
      href={`https://wa.me/${number.replace(/[^\d]/g, "")}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-bubble-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 hover:scale-110 active:scale-95 transition-transform duration-300"
    >
      <WhatsappLogo size={26} weight="fill" className="sm:hidden" />
      <WhatsappLogo size={30} weight="fill" className="hidden sm:block" />
    </a>
  );
};
